import { FC, useState } from 'react';
import { ReactComponent as TriangleIcon } from 'assets/icons/triangle.svg';
import { Switch } from '@headlessui/react';
import SelectSlotDropdown from '../SelectSlotDropdown/SelectSlotDropdown';
import BlockDropdown from '../BlockDropdown/BlockDropdown';
import { Controller } from 'react-hook-form';
import OptimizeWeeklyDurationDropdown from '../OptimizeWeeklyDurationDropdown/OptimizeWeeklyDurationDropdown';

interface OptimizeScheduleSectionProps {
  control: any;
}

const OptimizeScheduleSection: FC<OptimizeScheduleSectionProps> = ({
  control,
}) => {
  const [isExapanded, setIsExapanded] = useState(true);

  return (
    <div className="flex flex-col text-14 leading-[2.1rem]">
      <button
        className="flex items-center gap-x-0.8"
        onClick={() => setIsExapanded((isExapanded) => !isExapanded)}
      >
        <TriangleIcon
          className={`${
            isExapanded ? '' : '-rotate-90'
          } transition-transform w-1.6 h-1.6`}
        />
        <span className="font-bold text-16 leading-[2.2rem] text-darkest-grey">
          Optimize Hygiene Schedule
        </span>
      </button>
      {isExapanded && (
        <Controller
          control={control}
          name="isOptimizeSchedule"
          render={({ field }) => {
            const { value } = field;
            return (
              <div className="space-y-2.1">
                <div className="flex gap-x-1.6 items-center mt-1">
                  <Switch
                    {...field}
                    checked={value}
                    className={`${
                      value ? 'bg-magenta' : 'bg-[#78788029]'
                    } relative inline-flex h-3.1 w-5.1 items-center rounded-full`}
                  >
                    <span
                      className={`${
                        value ? 'translate-x-[2.3rem]' : 'translate-x-[2px]'
                      } inline-block h-2.5 w-2.5 transform rounded-full transition bg-white`}
                    />
                  </Switch>
                  <span className="uppercase">{value ? 'On' : 'Off'}</span>
                </div>
                {value && (
                  <div className="space-y-1.6">
                    <SelectSlotDropdown control={control} />
                    <BlockDropdown control={control} />
                    <OptimizeWeeklyDurationDropdown control={control} />
                  </div>
                )}
              </div>
            );
          }}
        />
      )}
    </div>
  );
};

export default OptimizeScheduleSection;
